module.exports = require('./helpers/bundle-url').getBundleURL('75xNe') + "logo.c51670a8.svg";